import { createSlice } from "@reduxjs/toolkit";

const favoriteSlice = createSlice({
  name: "favorite",
  initialState: {
    favorites: [],
    loading: false,
    error: false,
    totalPage: 0,
    totalItem: 0
  },
  reducers: {
    getFavorite: (state) => {
      state.loading = true;
      state.error = false;
    },
    getFavoriteSuccess: (state, action) => {
      state.loading = false;
      state.favorites = action.payload.data;
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getFavoriteFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    removeFavorite: (state) => {
      state.loading = true;
      state.error = false;
    },
    removeFavoriteSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    removeFavoriteFailed: (state) => {
      state.loading = false;
      state.error = false;
    },
  },
});

export const favoriteActions = favoriteSlice.actions;
export default favoriteSlice.reducer;
